export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9144.aab4b3fa.jpg";